exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audit-dialog .el-dialog__body{margin:0 30px}.audit-dialog /deep/ .el-dialog .el-dialog__footer{margin-top:0}", ""]);

// exports
